import { Space, Typography } from "antd";
import { EazyLoader } from "./EazyLoader";
import ProjectsGallery from "./ProjectsGallery/ProjectsGallery";
import diamondLoader from "../assets/Loader_Studio_Diamond19.json";
import { TextEffect } from "./ui/text-effect";
type Props = {
  hasProjects: boolean;
  projectExists?: boolean;
};

export function NoProjectSelectedScreen({ hasProjects, projectExists }: Props) {
  const isOnHomeURI = window.location.pathname === "/";
  if (isOnHomeURI) {
    return (
      <Space
        style={{
          justifyContent: hasProjects ? "" : "center",
          height: "100%",
        }}
        align={hasProjects ? undefined : "center"}
        className={"NoProjectSelectedScreen"}
        direction="vertical"
      >
        {hasProjects ? (
          <ProjectsGallery />
        ) : (
          <>
            <Typography.Title level={3}>
              Start by creating a project in the platform
            </Typography.Title>
            <EazyLoader size={400} isLoop={false} />
          </>
        )}
      </Space>
    );
  } else {
    return (
      <Space
        style={{
          padding: "1rem",
          justifyContent: "center",
          height: "100%",
          width: "100%",
          backgroundColor: "var(--background)",
        }}
        align="center"
        className={"NoProjectSelectedScreen"}
        direction="vertical"
      >
        {projectExists ? (
          <div className="loading-screen-content">
            <EazyLoader
              size={120}
              isLoop={true}
              customAnimation={diamondLoader}
            />
            <TextEffect
              per="char"
              preset="blur"
              className="loading-text-animated"
            >
              Loading your project data
            </TextEffect>
          </div>
        ) : (
          <div className="mt-8-center">
            <Typography.Title level={3}>
              Oops, we can't find what you are looking for
            </Typography.Title>
            <Typography.Title>
              <Typography.Link
                href="mailto:support@blings.io"
                style={{
                  color: "white",
                  borderBottom: "2px solid #fff",
                  paddingBottom: "2px",
                  fontSize: "30px",
                }}
              >
                Contact us
              </Typography.Link>
            </Typography.Title>
            <EazyLoader size={400} isLoop={false} />
          </div>
        )}
      </Space>
    );
  }
}
